import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table , Modal} from "antd";
// import { Table, Checkbox, Modal, Button } from "antd";

// import getPointsColumns from "../../../const/columns/pointsColumns";
import { deleteDairiesServer, getDairiesServer } from "../../../apis/DatesForDairiesApi";
import getDatesForDairiesColumns from "../../../const/columns/datesForDairiesColumns";
import AddDatesDairies from "./AddDatesDairies";
import useTableDragScroll from "../../../hooks/useTableDragScroll";

const DatesDairies = () => {
  const [dairies, setDairies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false)

  useEffect(() => {
    fetchDairies();
  }, []);

  useTableDragScroll([loading, dairies]);

  const fetchDairies = async () => {
    try {
      const res = await getDairiesServer();
      setDairies(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deletePoints = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Dairy?"
    );
    if (isConfirmed) {
      const res = await deleteDairiesServer(id);
      console.log(res)
      setLoading(true);
      fetchDairies();
    }
  };
//   const handleModalClose = () => {
//     setIsModalVisible(false);
//   };
//   const handleSendNotifications = () => {
    
//     setIsModalVisible(true);
//   };
  const columns = getDatesForDairiesColumns(deletePoints);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link to="/AddDairies" className="btn add-new btn-primary mb-3">
                Add Dairies
              </Link>
            </div>
            {/* <Button
              className="btn btn-primary mb-3"
              onClick={handleSendNotifications}
            >
              Add Dairies
            </Button> */}
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={dairies?.length > 0 ? dairies : []}
                  className="table-striped "
                  rowKey={(record) => record.id}
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* <Modal
      title = "Add Dairies"
      open = {isModalVisible}
      footer={null}
      onCancel={handleModalClose}
      width={600}
      
      >
 {isModalVisible && (
          <AddDatesDairies  onClose={handleModalClose} />
        )}
      </Modal> */}
    </>
    
  );
};

export default DatesDairies;

